import { Button, Checkbox, IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import Tooltip from '@mui/material/Tooltip';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import { createNewCategory, updateCategoryDetails } from '../../../../../utils/cmsUtils';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../../../../utils/formUtils';
import { fetchAllCategorys, fetchChannelNumberList } from '../../../cmsSlice';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import InfoIcon from '@mui/icons-material/Info';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const CategoryCreate = (props) => {
  const dispatch = useDispatch();
  const { toggleDrawer, category, hotelId, showLoader = () => {} } = props;
  const [loading, setLoading] = useState(false);
  const [valid, setValid] = useState(false);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    categoryName: {
      value: '',
      fieldName: 'Category Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    categoryCode: {
      value: '',
      fieldName: 'Category Code',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    status: {
      value: false,
      fieldName: 'Status',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    setValid(formDataValidate(formData, false));
  });

  useEffect(() => {
    if (category) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = category[field];
      }
      currFields.status.value = category.isActive;
      currFields.categoryName.value = category.name;
      currFields.categoryCode.value = category.code;
      setFormData(currFields);
    }
  }, [category]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleActiveChange = (event) => {
    const currField = { ...formData.status };
    currField.value = event.target.checked;
    setFormData({ status: currField });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      setLoading(true);
      const payload = {};
      for (let field in formData) {
        payload[field] = formData[field].value;
      }
      payload.name = formData.categoryName.value;
      payload.code = formData.categoryCode.value;
      payload.isActive = formData.status.value;
      try {
        dispatch(stepUpLoaderCount());
        if (category) {
          payload.id = category.id;
          await updateCategoryDetails(payload, hotelId, selectedLang);
          notificationManager('success', 'Category updated successfully');
        } else {
          await createNewCategory(payload, hotelId, selectedLang);
          notificationManager('success', 'Category created successfully');
        }
        dispatch(fetchAllCategorys(hotelId));
        dispatch(fetchChannelNumberList(hotelId));

        setLoading(false);
        toggleDrawer('', false, '');
      } catch (error) {
        setLoading(false);
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          category
            ? notificationManager('danger', 'Category updation failed')
            : notificationManager('danger', 'Category creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      notificationManager('danger', 'Enter all required fields');
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  return (
    <form className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-10'>
            <span className='page-title'>{category ? 'Edit Category' : 'Add Category'}</span>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <h4 className='tab-title'>Details</h4>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.categoryName}
                handleInputChange={(e) => {
                  setFormData({ categoryName: e });
                }}
                maxLength={100}
                multiline={true}
                endAdornment={true}
                characterCount={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.categoryCode}
                handleInputChange={(e) => {
                  setFormData({ categoryCode: e });
                }}
                multiline={true}
                endAdornment={true}
                characterCount={true}
                maxLength={50}
              />
            </div>
          </div>
          <div className='row p-0'>
            <div className='col-md-3 mb-3'>
              <div className='d-flex align-items-center'>
              <Checkbox
                checked={formData?.status?.value}
                onChange={handleActiveChange}
                className='status-checkbox'
                color='primary'
              />
              <span style={{ fontWeight: 500 }}>Active</span>
              <CustomToolTip
                title='Deactivating a Category hides it from the TV'
                placement='right-end'
              >
                <InfoIcon style={{ marginLeft: 8}} />
              </CustomToolTip>
              </div>
            </div>
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              disabled={loading || !valid}
              onClick={handleSubmit}
              variant='contained'
              color='primary'
              className='me-3'
              size='large'
            >
              {category ? 'Update' : 'Add'}
            </Button>
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};
export default CategoryCreate;
